import React from 'react'
import dayjs from '@helpers/dayjs'
import orderStatuses from '@helpers/labels/orderStatuses'
import FormatNumber from '@i18n/formatNumber/Component'
import classNames from 'classnames'
import Link from 'next/link'
import {useTranslation} from 'next-i18next'

import Review from './Review'

import styles from './styles.module.css'

export default function Order(props) {
  const {order} = props
  const itemWithImage = order.items.find(
    item => item.product.images && item.product.images[0] && item.product.images[0].url
  )
  const {t} = useTranslation('website', {keyPrefix: 'orders.order'})

  const showConfirmStatus = order.isScheduled && order.orderStatus === 'pending'
  const confirmStatus = order.isConfirmed ? 'Confirmado' : 'Por Confirmar'

  return (
    (<Link href={`/track/${order._id}`} className={styles.container}>

      <div
        className={styles.image}
        style={{
          backgroundImage: itemWithImage ? `url(${itemWithImage.product.images[0].url})` : null
        }}
      />
      <div className={styles.info}>
        <div className={styles.top}>
          <div className={styles.totalPrice}>
            <FormatNumber value={order.totalPrice} />
          </div>
          {order.paymentStatus !== 'done' ? (
            <div className={styles.unpaid}>{t('labelUnpaid')}</div>
          ) : order.orderStatus === 'done' ? (
            <Review order={order} />
          ) : (
            <div
              className={classNames(styles.status, {
                [styles.confirmedStatus]: showConfirmStatus && order.isConfirmed
              })}>
              {showConfirmStatus ? confirmStatus : orderStatuses[order.orderStatus]}
            </div>
          )}
        </div>
        <div className={styles.items}>{order.productsResume}</div>
        <div className={styles.space} />
        <div className={styles.bottom}>
          <div className={styles.code}>{t('labelIdentifierOrder', {code: order.code})}</div>
          <div className={styles.date}>{dayjs(order.createdAt).format('LL')}</div>
        </div>
      </div>

    </Link>)
  );
}
